<div class="col-lg-3 m-auto">
    <div class="row g-0 my-1">
        <h1 class="text-center">Cart</h1>
    </div>
    <div *ngIf="cart.entries.length == 0">
        <div class="row g-0 my-1 text-center">
            <h2>No items in cart</h2>
            <h3>Visit our <a href="/shop">shop</a></h3>
        </div>
    </div>
    <div *ngIf="cart.entries.length != 0">
        @for (entry of cart.entries; track $index) {
        <hr>
        <div class="row g-0 my-1">
            <span>{{ entry.productName }}</span>
            <span>Quantity: {{ entry.quantity }}</span>
            <div class="d-inline-flex justify-content-between">
                <div class="col-auto">
                    <button class="btn btn-secondary rounded-pill rounded-end-0" (click)="removeFromCart(entry.productId)">
                        <fa-icon [icon]="faMinus" />
                    </button>
                    <button class="btn btn-primary rounded-pill rounded-start-0" (click)="addToCart(entry.productId)">
                        <fa-icon [icon]="faPlus" />
                    </button>
                </div>
                <div class="col-auto">
                    <span>Price: ${{ entry.price / 100 }}</span>
                </div>
            </div>
        </div>
        }
        <div class="row g-0 my-1 text-center">
            <span>Subtotal: ${{ (cart.subtotal / 100).toFixed(2) }}</span>
        </div>

        <div class="row g-0 my-1 text-center">
            <button class="btn btn-primary rounded-pill" [routerLink]="['/checkout']">
                <span>Checkout</span>
            </button>
        </div>
    </div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
